import { render, staticRenderFns } from "./StockDialog.vue?vue&type=template&id=775990a6&scoped=true"
import script from "./StockDialog.vue?vue&type=script&lang=js"
export * from "./StockDialog.vue?vue&type=script&lang=js"
import style0 from "./StockDialog.vue?vue&type=style&index=0&id=775990a6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775990a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('775990a6')) {
      api.createRecord('775990a6', component.options)
    } else {
      api.reload('775990a6', component.options)
    }
    module.hot.accept("./StockDialog.vue?vue&type=template&id=775990a6&scoped=true", function () {
      api.rerender('775990a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketingFunction/superSubsidyV2/components/StockDialog.vue"
export default component.exports